import React from "react";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";
import differenceInDays from "date-fns/difference_in_days";
import differenceInMinutes from "date-fns/difference_in_minutes";
import format from "date-fns/format";

export default (
  { first_published, published_date, status },
  verbose = false
) => {
  if (published_date) {
    const month = verbose ? "MMMM" : "MMM";
    const now = new Date();
    const updated =
      first_published &&
      differenceInMinutes(published_date, first_published) > 5
        ? "updated "
        : "";
    // Show relative time if article was published less than a day ago
    if (differenceInDays(published_date, now) > -1) {
      // Less than an hour old: "[x] mins ago"
      // Less than a day but more than an hour: "[x] hrs ago"
      let distance = distanceInWordsStrict(now, published_date, {
        addSuffix: true,
      });
      return `${updated}${distance.replace("minute", "min")}`;
    }
    // Otherwise show the absolute date
    else {
      return `${updated}${format(published_date, `${month} D, YYYY`)}`;
    }
  } else {
    if (status && status !== "published") {
      return <i>unpublished</i>;
    } else {
      // Published items with a published date of null are a big no-no.
      // This maybe should even throw an error.
      return null;
    }
  }
};
